import {
  EDIT_PROFILE,
  IS_SET_DEFAULT_WALLET_OPENED,
  PROFILE_ERROR,
  PROFILE_SUCCESS,
  RESET_PROFILE_DATA,
  RESET_PROFILE_FLAG,
  SET_AGREEMENT,
  SET_PROFILE_DATA,
} from './actionTypes';

const initialState = {
  error: null,
  success: null,
  isAuth: false,
  user: {
    country: null,
    default_wallet_address: null,
    needToFirstStructure: { percent: 0, value: 0 },
    needToAllStructure: { percent: 0, value: 0 },
    createdAt: null,
    deposit: null,
    email: null,
    fullName: null,
    level: 0,
    investorLevel: null,
    base_deposit_level: 0,
    referrer_id: null,
    referrer_name: null,
    mobile: null,
    partnerId: null,
    photo: null,
    role: { access: [] },
    username: null,
    agreement: null,
    kyc_positive_result: false,
    kyc_status: null,
  },
  isSetDefaultWalletModalOpened: false,
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE:
      return {
        ...state,
      };

    case SET_AGREEMENT:
      return { ...state, user: { ...state.user, agreement: action.payload } };

    case SET_PROFILE_DATA:
      return {
        ...state,
        isAuth: true,
        user: { ...state.user, ...action.payload, kyc_positive_result: action.payload.kyc_positive_result, kyc_status: action.payload.kyc_status },
      };

    case RESET_PROFILE_DATA:
      return {
        ...state,
        isAuth: false,
        user: { ...initialState.user },
      };
    case PROFILE_SUCCESS:
      return {
        ...state,
        success: action.payload,
      };

    case PROFILE_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case RESET_PROFILE_FLAG:
      return {
        ...state,
        success: null,
      };

    case IS_SET_DEFAULT_WALLET_OPENED:
      return {
        ...state,
        isSetDefaultWalletModalOpened: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default profile;
// {
//     country: null,

//     createdAt: null,
//     deposit: null,
//     email: null,
//     fullName: null,
//     level: null,
//     mobile: null,
//     partnerId: null,
//     photo: null,
//     username: null,
//   }
